<template lang="pug">
.business
  .title-block
    .en PROGRAM
    .cn 学习交流
  .text-block
    img(src="../assets/imgs/business/workshop.jpg")
    .title
      .cn 前沿工作坊
      .en forontier workshop
    .desc
      p 深入了解全球最领先的科技，提供市场化视角的思考、对未来产品与应用的建议，为实验室项目商业化提供路径。
      .more
        a(href="/intro#workshop") 了解更多 >
  .text-block
    img(src="../assets/imgs/business/fieldstudy.jpg")
    .title
      .cn 近场研究
      .en Field Study
    .desc
      p CEO 对 CEO，真问题对真问题。每期走进一家优秀热门科技公司，通过 CEO 间内部探讨和闭门交流，促进有价值的思考，推动经验分享与洞见碰撞，推动没有边界的创新思维和合作可能。
      .more
        a(href="/intro#fieldstudy") 了解更多 >
  .title-block
    .en Overclocking
    .en camp
    .cn 超频之旅
  .text-block
    img(src="../assets/imgs/business/overclocking.jpg")
    //- .title
      .cn 超频之旅
      .en Overclocking camp
    .desc
      p 与最优秀的企业家一起在全球范围内从前沿的科技到创新的思想，去寻求认知的突破和升级，也在共同的交流和思考之中进行思维的徒步。
      .more
        a(href="/intro#overclocking") 了解更多 >
</template>

<script>
export default {
  name: 'vcontent',
}
</script>

<style lang="stylus">
@import '../assets/css/var'

.business
  background #fff
  color #000
  .en
    font-family 'BebasNeue'
    line-height 1em
    text-transform uppercase
  .more
    padding-top 20px
    padding-bottom 15px
    a
      color #5EC5FF
  .title-block
    padding 40px 20px 15px 20px
    .en
      font-size 48px
    .cn
      font-size 18px
  .text-block
    position relative
    background #000
    color #fff
    img
      width 100%
    .title
      position absolute
      top 40vw
      left 20px
      .cn
      .en
        font-size 32px
      .cn
        font-family 'FZLTTHCJW--GB1-0'
    .desc
      padding 20px
      p
        font-size 14px
        line-height 1.5
    &.no-p
      color #000
      background #fff
</style>



// WEBPACK FOOTER //
// Business.vue?67f8c962